import axios from 'axios';

import { getAvatarRuntimeBaseUrl } from './modelRegistry';

type SpeechTokenResponse = {
  token?: unknown;
  region?: unknown;
};

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

function isValidSpeechTokenResponse(payload: unknown): payload is Required<SpeechTokenResponse> {
  if (!payload || typeof payload !== 'object') {
    return false;
  }

  const data = payload as SpeechTokenResponse;
  return isNonEmptyString(data.token) && isNonEmptyString(data.region);
}

function buildSpeechTokenEndpoints(): string[] {
  const endpoints = ['/talk/get-speech-token'];
  const runtimeBase = getAvatarRuntimeBaseUrl() || 'https://avatar.camlinconnect.com.au';

  if (runtimeBase) {
    endpoints.push(`${runtimeBase.replace(/\/+$/, '')}/talk/get-speech-token`);
  }

  return [...new Set(endpoints)];
}

export async function getTokenOrRefresh() {
  let lastError = 'Speech token endpoint returned an invalid response.';

  for (const endpoint of buildSpeechTokenEndpoints()) {
    try {
      const res = await axios.get(endpoint, {
        timeout: 10000,
        headers: {
          Accept: 'application/json'
        }
      });

      if (isValidSpeechTokenResponse(res.data)) {
        console.log('Speech token retrieved successfully');
        return { authToken: res.data.token.trim(), region: res.data.region.trim() };
      }

      lastError = `Speech token endpoint returned invalid payload from ${endpoint}`;
      console.warn(lastError, { dataType: typeof res.data });
    } catch (err: any) {
      lastError = err?.message || `Failed to fetch speech token from ${endpoint}`;
      console.warn(`Error fetching speech token from ${endpoint}:`, lastError);
    }
  }

  console.error('Error fetching speech token:', lastError);
  return { authToken: null, region: null, error: lastError };
}
